import { getDomain } from 'www/utils/get-domain';
export class PodcastApiHooks {
  constructor() {
    // add url for the specific env
    // this.endpoint = `https://www.qa01.medscape.com/api/v1/podcast/episodesbyarticleid/958311`;
    this.endpoint = `https://www.${getDomain()}medscape.com/api/v1/podcast/episodesbyarticleid/${this.getArticleID()}`;
    this.callEndpiont(this.endpoint);
  }
  callEndpiont(url) {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // Pass the result parameter to another function
        const {id, showId} = data;
        if(id && showId) {
          this.setPageTargets(id, showId);
        }
      })
      .catch((error) => console.log(error));
  }
  setPageTargets(id, showId) {
    webmd.ads2.setPageTarget("epid", id);
    webmd.ads2.setPageTarget("feedid", showId);
  }
  getArticleID() {
    const articleUrl = window.location.pathname.split("/");
    let articleId = "";
    if (articleUrl.length > 1) {
      articleId = articleUrl[articleUrl.length - 1];
    } else {
      throw "URL Parsing Error.";
    }
    return articleId;
  }
}
